import { CheckBox, Layer } from 'grommet';
import { useId, useState } from 'preact/hooks';
import { useDispatch } from 'react-redux';

import { useSelector } from '@/redux/helper';
import { setShouldSkipOnboardingPrompt } from '@/redux/slices/settings/ambient/action';

const AmbientOnboardingModal = () => {
  const id = useId();
  const dispatch = useDispatch();
  const shouldSkipOnboardingPrompt = useSelector((state) => state.settings.ambientMode.shouldSkipOnboardingPrompt);
  const [doNotShowAgain, setDoNotShowAgain] = useState(false);
  const [isShowing, setIsShowing] = useState(true);

  if (shouldSkipOnboardingPrompt || !isShowing) {
    return null;
  }

  const onDismiss = () => {
    if (doNotShowAgain) {
      dispatch(setShouldSkipOnboardingPrompt(true));
    }
    setIsShowing(false);
  };

  return (
    <Layer animation="fadeIn" className="!w-[calc(100%-3rem)] !max-w-[406px] !overflow-auto !rounded-b-2xl !rounded-t-2xl">
      <div className="flex flex-col justify-center rounded-t-2xl desktop:rounded-b-2xl">
        <div className="mt-6 text-center">
          <i className="text-6xl">🪷</i>
        </div>
        <div className="flex flex-col gap-6 px-6">
          <div>
            <h3 className="preflight preflight-h3 mb-2 text-center text-2xl font-bold text-black">
              Introducing Ambiance Mode
            </h3>
            <p className="preflight preflight-p text-center text-base text-grey-6">
              Choose your soundtrack, and sit back with the best of zoolife livestreams on auto-rotation.
            </p>
          </div>
          <div className="mb-2 flex items-center gap-2">
            <CheckBox
              id={`${id}-dont-show-again`}
              checked={doNotShowAgain}
              onChange={() => setDoNotShowAgain(!doNotShowAgain)}
            />
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className="text-base text-grey-6" htmlFor={`${id}-dont-show-again`}>
              Don&rsquo;t show this again
            </label>
          </div>
          <div className="mb-6 flex flex-col gap-2">
            <button
              type="button"
              className="preflight preflight-button h-12 rounded-full bg-primary-green p-4 text-center text-base font-medium leading-none text-white hover:bg-secondary-green"
              onClick={onDismiss}
            >
              Start
            </button>
          </div>
        </div>
      </div>
    </Layer>
  );
};

export default AmbientOnboardingModal;
